import { RegionsTree } from "./Region";
import { Point, Geometry } from "geojson";


export class Site {
    site_id:                 number;
    site_ip_address:         string;
    site_mac_address:        string;
    site_name:               string;
    site_description:        string;
    site_mode:               string;
    site_discovered:         string;
    site_status:             string;
    site_nms_address:        string;
    site_event_seq_last:     number;
    site_event_seq_cur:      number;
    site_alarm_count:        number;
    site_poll:               string;
    site_last_poll:          string;
    site_poll_method:        string;
    site_poll_interval:      number;
    site_polling_state:      string;
    site_evt_last_change:    number;
    site_trend_evt_seq_last: number;
    site_trend_evt_seq_cur:  number;
    site_version:            number;
    site_type:               string;
    site_alarm_group_id:     number;
    site_monitor_status:     string;
    region_id:               number; //TODO: this should be site_region_id... rename... not renaming now incase it breaks something
    site_location:           Point;
}